<template>
    <div id="not-found-container">
        <h3>404</h3>
        <div id="vertical-sep"></div>
        <h3>Not Found</h3>
    </div>
</template>

<script>
export default {
    name: "NotFound"
}
</script>

<style lang="scss">
$primary-color: #455A64;

    #not-found-container {
        display: flex;
        height: 100vh;
        justify-content: center;
        align-items: center;
        color: $primary-color;

        h3 {
            padding: 0 15px;
            //border: 1px solid green;
        }

        #vertical-sep {
            // Create a vertical line
            border-left: 3px solid $primary-color;
            height: 40px;
            transform: translateY(-3px);
        }
    }
</style>